import * as _ from 'lodash';
import { Observable } from 'rxjs';
import { computed, effect, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

import { TRequestName } from 'src/assets/common/enums/request-names.g';
import { IImageDto } from 'src/assets/common/models/image-dto.g';

export type EntityKeyName = 'id' | 'guid';

@Injectable()
export abstract class _ModelService
{
    abstract dtoModel_alter(dataModel?: any): any;
    abstract dataModel_alter(dtoModel?: any, formModel?: any): any;
    abstract requestNames: TRequestName;

    abstract dataModel$$: WritableSignal<any>;
    abstract dataModel$: Observable<unknown>;
    abstract dtoModel$$: Signal<any> | WritableSignal<any>;
    abstract photo$$: WritableSignal<IImageDto | null>;
    abstract photos$$: WritableSignal<IImageDto[]>;

    protected _dataModel$$ = signal<any>(null);
    protected _dataModel$ = toObservable(this._dataModel$$);

    protected _photo$$ = signal<IImageDto | null>(null);
    protected _photos$$ = signal<IImageDto[]>([]);
    
    private __dtoModel$$ = signal<any>(null);
    protected _computed_dtoModel$$ = computed(() => this.__dtoModel$$());

    constructor() {
        effect(() => {
            const __dtoModel = this.dtoModel$$();
            const __dataModel = this.dataModel_alter(__dtoModel);

            this.dataModel$$.set(__dataModel);
        })
    }

    reset() {
        this.dtoModel_set(null);
    }

    dtoModel_merge(dtoModel: any) {
        const __dtoModel = this.dtoModel$$();
        // Alleen gedefinieerde, niet-null waarden mergen: een uit het form herbouwde DTO
        // bevat default-null voor niet-bewaarde navigatie-DTO's (bv. pageDto/pageComponentDto/
        // claimActionDto). Een platte spread zou die over de goede cache-waarden heen zetten,
        // waardoor afgeleide velden (page_displayName, claim_name, …) tijdelijk leeglopen.
        const __newDtoModel = {...__dtoModel};
        for (const [__key, __value] of Object.entries(dtoModel ?? {})) {
            if (__value !== null && __value !== undefined) { __newDtoModel[__key] = __value; }
        }

        this.dtoModel_set(__newDtoModel);
    }

    dtoModel_set(dtoModel: any) {
        this.__dtoModel$$.set(dtoModel);
    }

    formModel_toDto(formModel: any): any {
        return this.dataModel_alter()
    }
}

